<template>
  <div
    class="background-double-light-gray border-radius-8 padding-8 position-relative max-height-85 mobile-margin-top-8 tablet-margin-top-8"
  >
    <span
      @click.stop="handleOpenExpandedChartModal()"
      class="border--solid border--primary-100 border-radius-8 color-primary position-absolute left-8 z-index-1 cursor--pointer width-28 height-28 flex-center"
    >
      <mdicon name="arrow-expand-all" size="20" />
    </span>
    <AverageBarChart
      :labels="labels"
      :series="splineSeries"
      titleText=""
      width="400"
      height="80"
      :columnPointWidth="20"
      :xAxisLabels="false"
      :yAxisLabels="false"
      backgroundColor="#F9F9F9"
      :yAxisMax="yAxisMaxAverageBarChart"
    />
    <Teleport to="body">
      <Modal
        :show="isExpandedChart"
        :title="modalTitle"
        :closeOnBackdrop="false"
        :hasClose="true"
        :hasFooter="false"
        @close="handleCloseExpandedChartModal"
      >
        <template #body>
          <Tabs class="" :tabs="tabs">
            <template #tab-0>
              <AverageBarChart
                class="margin-bottom-16"
                :labels="averageBarLabels"
                :series="averageBarSeries"
                :isEnabledLegend="true"
                :yAxisMax="yAxisMaxAverageBarChart"
              />
            </template>
            <template #tab-1>
              <RadarChart
                :labels="radarLabels"
                :series="radarSeries"
                :yAxisRange="radarYAxisRange"
                :yAxisMin="yAxisMin"
                :yAxisMax="yAxisMax"
              />
            </template>
          </Tabs>
        </template>
      </Modal>
    </Teleport>
  </div>
</template>

<script>
import Teleport from "vue2-teleport";
import { Modal, Tabs } from "@/components/re-design";
import {
  AverageBar as AverageBarChart,
  Radar as RadarChart,
} from "@/components/charts";
import { ref, toRefs } from "vue";
import { generateLang } from "@/shared/utils";
export default {
  components: {
    Teleport,
    AverageBarChart,
    RadarChart,
    Modal,
    Tabs,
  },
  props: {
    modalTitle: {
      type: String,
      default: "",
    },
    labels: {
      type: Array,
      default: () => [],
    },
    splineSeries: {
      type: Array,
      default: () => [],
    },
    averageBarLabels: {
      type: Array,
      default: () => [],
    },
    averageBarSeries: {
      type: Array,
      default: () => [],
    },
    radarLabels: {
      type: Array,
      default: () => [],
    },
    radarSeries: {
      type: Array,
      default: () => [],
    },
    radarYAxisRange: {
      type: Array,
      default: () => [],
    },
    yAxisMaxAverageBarChart: {
      type: Number,
      default: 5,
    },
    yAxisMin: {
      type: Number,
      default: 0,
    },
    yAxisMax: {
      type: Number,
      default: 5,
    },
  },
  setup(props) {
    // generate props data
    const {
      modalTitle,
      labels,
      splineSeries,
      averageBarLabels,
      averageBarSeries,
      radarLabels,
      radarSeries,
      radarYAxisRange,
    } = toRefs(props);

    const tabs = [
      {
        text: generateLang(["barChart"]),
      },
      {
        text: generateLang(["radarChart"]),
      },
    ];

    const isExpandedChart = ref(false);
    const handleOpenExpandedChartModal = () => (isExpandedChart.value = true);
    const handleCloseExpandedChartModal = () => (isExpandedChart.value = false);

    // return data to be used in template
    return {
      labels,
      splineSeries,
      averageBarLabels,
      averageBarSeries,
      radarLabels,
      radarSeries,
      radarYAxisRange,
      tabs,
      isExpandedChart,
      handleOpenExpandedChartModal,
      handleCloseExpandedChartModal,
    };
  },
};
</script>
